export const FLATBED_T = 35;

export function unitWeightKg(p) {
  if (!p) return null;
  const s = p.specs || {};
  const direct = p.unit_weight_kg ?? s.unit_weight_kg ?? s.bag_weight_kg ?? p.weight_kg;
  if (direct != null && Number(direct) > 0) return Number(direct);
  if (s.kg_per_m && s.length_m) return Number(s.kg_per_m) * Number(s.length_m);
  return null;
}

export const lineWeightKg = (p, qty) => { const u = unitWeightKg(p); return u == null ? null : u * (Number(qty) || 0); };

export const fmtKg = (kg) => (kg == null ? null : kg >= 1000 ? `${(kg / 1000).toLocaleString(undefined, { maximumFractionDigits: 2 })} t` : `${kg.toLocaleString(undefined, { maximumFractionDigits: 1 })} kg`);

export const needsFlatbed = (kg) => kg != null && kg >= FLATBED_T * 1000;

export const haulageLink = (kg, desc) => `/haulage?category=${kg > 10000 ? "heavy_duty_truck" : "flatbed_truck"}&weight=${Math.round(kg)}&kind=commercial&desc=${encodeURIComponent(desc || "Bulk material load")}`;
